var BASWebServices;
(function (BASWebServices) {
    var ServiceOption = (function () {
        function ServiceOption() {
        }
        ServiceOption.parseCMDIJSON = function (currentService, operationName) {
            var returnHTML = "<div data-ng-init='expertShow=false'>";
            var developerInformation = currentService.Developer;
            var allParameters = currentService.Input.Parameter;
            for (var j = 0; j < allParameters.length; j++) {
                var currentParameter = allParameters[j];
                var parameterName = currentParameter.Name;
                var additionalAttributes = " ";
                if ((operationName == "runPipeline" || operationName == "runPipelineWithASR" || operationName == "runMAUS") && j == (ServiceOption.MAX_NUM_DEFAULT_OPTIONS_FOR_PIPELINE + 1)) {
                    returnHTML += "<br/><span id='expertOptions' style='cursor: pointer;' data-ng-init='expertShow=false' data-ng-click='expertShow=!expertShow'><b>Expert Options</b> (<i>click to <span data-ng-show='expertShow' data-ng-hide='!expertShow'>hide):</span><span data-ng-show='!expertShow' data-ng-hide='expertShow'>show)</span></i></span>";
                }
                if ((operationName == "runPipeline" || operationName == "runPipelineWithASR" || operationName == "runMAUS") && j >= (ServiceOption.MAX_NUM_DEFAULT_OPTIONS_FOR_PIPELINE + 1)) {
                    var serviceRestrictionClause = currentParameter.displayName.match(/\(([A-Z0-9,]*)\)/);
                    if (serviceRestrictionClause) {
                        var allowedServices = serviceRestrictionClause[1];
                        additionalAttributes = " data-ng-show='expertShow && soc.showOptionSuitableForServices(\"" + allowedServices + "\")' class='expertOptions' ";
                    }
                    else {
                        additionalAttributes = " data-ng-show='expertShow' class='expertOptions' ";
                    }
                }
                if (currentParameter.isConfigurationParameter == 'true') {
                    if ((operationName == "runPipelineWithASR" || operationName == "runEMUMagic" || operationName == "runSpeakDiar") && parameterName == "TEXT") {
                        continue;
                    }
                    if ((operationName == "runSubtitle") && parameterName == "transcription") {
                        continue;
                    }
                    var dataType = currentParameter.DataType;
                    var dataCategory = currentParameter.DataCategory;
                    var description = currentParameter.Description;
                    var defaultValue = currentParameter.Default;
                    var displayName = currentParameter.displayName;
                    var selectInput = "";
                    if (!(currentParameter.isInternalDefaultConfigurationParameter === undefined) && currentParameter.isInternalDefaultConfigurationParameter == "true") {
                        var paramCode = '<input type="hidden" ';
                        paramCode += ' id="' + parameterName + '" ';
                        paramCode += ' name="' + parameterName + '" ';
                        paramCode += ' type="text"';
                        paramCode += ' value="' + defaultValue + '"';
                        paramCode += ' class="' + BASWebServices.ConfigService.STANDARD_CLASS_FOR_OPTIONS + '" ';
                        paramCode += '/>';
                        selectInput += paramCode;
                    }
                    else {
                        selectInput += '<div class="serviceoptionpair" ' + additionalAttributes + '>';
                        selectInput += '<span class="serviceoptionleft">';
                        if (displayName !== undefined)
                            selectInput += displayName;
                        else
                            selectInput += parameterName.toLowerCase().charAt(0).toUpperCase() + parameterName.toLowerCase().slice(1);
                        if (parameterName == "LANGUAGE") {
                            selectInput += '<span get-inventar-button data-ng-controller="GetInventarButtonController" class="serviceOptionInventarButton">Show inventory</span>';
                        }
                        selectInput += '</span>';
                        selectInput += '<span class="serviceoptionright"> ';
                        if (dataType == null) {
                            selectInput += ServiceOption.getHTMLForDataTypeNullHtml(dataType, parameterName, defaultValue, currentParameter.MIMEType);
                        }
                        else if (dataType == 'xsd:string') {
                            selectInput += ServiceOption.getHTMLForDataTypeStringHtml(dataType, parameterName, defaultValue, dataCategory, description, displayName, currentParameter.Values);
                        }
                        else if (dataType.lastIndexOf('xsd:boolean') != -1) {
                            selectInput += ServiceOption.getHTMLForDataTypeBooleanHtml(dataType, parameterName, defaultValue);
                        }
                        else if (dataType == 'xsd:integer' || dataType == 'xsd:float' || dataType == 'xsd:positiveInteger') {
                            selectInput += ServiceOption.getHTMLForDataTypeNumberHtml(dataType, parameterName, defaultValue);
                        }
                        else if ((dataType.lastIndexOf('xsd:positiveInteger') != -1 || dataType.lastIndexOf('xsd:integer') != -1 || dataType.lastIndexOf('xsd:decimal') != -1)
                            && (dataType.lastIndexOf('minInclusive') != -1 || dataType.lastIndexOf('maxInclusive') != -1)) {
                            if (dataType.lastIndexOf("\.") != -1) {
                                selectInput += ServiceOption.getHTMLForDataTypeDecimalWithRange(dataType, parameterName, defaultValue);
                            }
                            else {
                                selectInput += ServiceOption.getHTMLForDataTypePositiveIntegerWithRange(dataType, parameterName, defaultValue);
                            }
                        }
                        selectInput += '</span>';
                        selectInput += ServiceOption.getQuestionMarkHtml(description);
                        selectInput += '</div>';
                    }
                    returnHTML += selectInput;
                }
                else {
                    var paramCode = '<input type="hidden" ';
                    paramCode += ' id="' + parameterName + '" ';
                    paramCode += ' name="' + parameterName + '" ';
                    paramCode += ' value=""';
                    paramCode += ' class="' + BASWebServices.ConfigService.STANDARD_CLASS_FOR_OPTIONS + '" ';
                    paramCode += '/>';
                    returnHTML += paramCode;
                }
            }
            returnHTML += "</div>";
            return returnHTML;
        };
        ServiceOption.getQuestionMarkHtml = function (questionMarkText) {
            var returnHtml = "";
            returnHtml += '  <div class="questionMarkContainer" >';
            returnHtml += '    <div title="More information about this option" data-ng-controller="ToolTipController" data-ng-model="SHOW_TOOLTIP" data-ng-click="ttc.toogleToolTip()">';
            returnHtml += '      <div class="questionMark"></div>';
            returnHtml += '      <div data-ng-show="SHOW_TOOLTIP" class="modalDialog"><span data-ng-click="ttc.doNothing($event)" class="clarin-grey-background modalDialogBox modalDialogText">' + questionMarkText + ' <br/>Hint: Click the question mark again to make this dialogue disappear.</span></div>';
            returnHtml += '    </div>';
            returnHtml += ' </div>';
            return (returnHtml);
        };
        ServiceOption.getHTMLForDataTypeNullHtml = function (dataType, parameterName, defaultValue, mimetype) {
            var returnHtml = "";
            var fileExtensions = "";
            var acceptString = "";
            if (mimetype.lastIndexOf("text/plain") != -1) {
                fileExtensions = "txt";
                acceptString = ".txt";
            }
            else if (mimetype.lastIndexOf("text/x-plain-rul") != -1) {
                fileExtensions = "nrul rul";
                acceptString = ".rul,.nrul";
            }
            else if (mimetype.lastIndexOf("text/csv") != -1
                || mimetype.lastIndexOf("text/comma-separated-values") != -1) {
                fileExtensions = "csv";
                acceptString = ".csv";
            }
            returnHtml += '<input data-ng-controller="UploadElementController" \
                                                type="file"\
                                                class="uploadElementOption serviceoptions serviceoptionuploadbutton"   \
                                                data-ngf-select="uec.onFileSelect($files, \'' + parameterName + '\', \'' + fileExtensions + '\', true)"\
                                                data-ng-click="uec.deleteOptionFromService(\'' + parameterName + '\')"\
                                                accept="' + acceptString + '">\
                                        </input>';
            return (returnHtml);
        };
        ServiceOption.getHTMLForDataTypeStringHtml = function (dataType, parameterName, defaultValue, dataCategory, description, displayName, parameterValues) {
            var returnHtml = "";
            if (parameterValues === undefined) {
                var paramterNameForAngularVariable = parameterName.replace(/-/g, '');
                var inputType = "text";
                if (parameterName === "ACCESSCODE") {
                    inputType = "password";
                }
                returnHtml += '    <input type="' + inputType + '" class="serviceoptions ' + BASWebServices.ConfigService.STANDARD_CLASS_FOR_OPTIONS + '" ';
                returnHtml += '      data-ng-model="soc.' + paramterNameForAngularVariable + '"';
                returnHtml += '      data-ng-init="soc.' + paramterNameForAngularVariable + '=\'\'"';
                returnHtml += '      data-ng-change="soc.changeOfInput(\'' + parameterName + '\', soc.' + paramterNameForAngularVariable + ')"';
                returnHtml += '      pattern="\\S*"';
                if (defaultValue !== undefined) {
                    returnHtml += '       placeholder="' + defaultValue + '"';
                }
                else if (displayName !== undefined) {
                    returnHtml += '       placeholder="Please enter ' + displayName + '"';
                }
                else {
                    returnHtml += '       placeholder="Please enter ' + parameterName + '"';
                }
                returnHtml += '       id="' + parameterName + '"';
                returnHtml += '       name="' + parameterName + '"';
                returnHtml += '       size="14"';
                returnHtml += '       autocomplete="off"';
                returnHtml += '    >';
            }
            else {
                returnHtml += '<label class="soflow"><select class="serviceoptions soflow ' + BASWebServices.ConfigService.STANDARD_CLASS_FOR_OPTIONS + '" ';
                returnHtml += 'data-ng-model="soc.' + parameterName + '"';
                returnHtml += 'data-ng-init="soc.' + parameterName + '=\'' + defaultValue + '\'"';
                returnHtml += 'data-ng-change="soc.changeOfInput(\'' + parameterName + '\', soc.' + parameterName + ')"';
                returnHtml += ' id="' + parameterName + '"';
                returnHtml += ' name="' + parameterName + '"';
                returnHtml += '>';
                var allValues = parameterValues.ParameterValue;
                if (allValues["Value"] === undefined) {
                    for (var k = 0; k < allValues.length; k++) {
                        var value = allValues[k].Value;
                        var valueDescription = allValues[k].Description;
                        if (!(valueDescription == "")) {
                            returnHtml += '<option class="optionStyle" value="' + value + '" ';
                            if (value == defaultValue) {
                                returnHtml += 'selected="selected"';
                            }
                            returnHtml += '>';
                            if (valueDescription == null) {
                                returnHtml += value;
                            }
                            else {
                                returnHtml += valueDescription;
                            }
                        }
                    }
                }
                else {
                    var value = allValues["Value"];
                    returnHtml += '<option value="' + value + '" ';
                    if (value == defaultValue)
                        returnHtml += 'selected="selected"';
                    if (parameterName == "LANGUAGE") {
                        returnHtml += '>' + BASWebServices.ConfigService.GET_LANGUAGE_639_TO_WORD_MAPPING(value) + '</option>';
                    }
                    else {
                        returnHtml += '>' + value + '</option>';
                    }
                }
                returnHtml += '</select></label>';
            }
            return (returnHtml);
        };
        ServiceOption.getHTMLForDataTypeBooleanHtml = function (dataType, parameterName, defaultValue) {
            var returnHtml = "";
            var booleanValsSeperate;
            if (dataType.lastIndexOf("pattern") != -1) {
                var booleanVals = dataType.split("'");
                booleanValsSeperate = booleanVals[1].split("|");
            }
            else {
                booleanValsSeperate = ["true", "false"];
            }
            returnHtml += '<label class="soflow"> <select class="serviceoptions soflow ' + BASWebServices.ConfigService.STANDARD_CLASS_FOR_OPTIONS + '" ';
            returnHtml += 'data-ng-model="soc.' + parameterName + '"';
            returnHtml += 'data-ng-init="soc.' + parameterName + '=\'' + defaultValue + '\'"';
            returnHtml += 'data-ng-change="soc.changeOfInput(\'' + parameterName + '\', soc.' + parameterName + ')"';
            returnHtml += ' id="' + parameterName + '"';
            returnHtml += ' name="' + parameterName + '"';
            returnHtml += '>';
            for (var k = 0; k < booleanValsSeperate.length; k++) {
                returnHtml += '<option value="' + booleanValsSeperate[k] + '" ';
                if (booleanValsSeperate[k] == defaultValue)
                    returnHtml += 'selected="selected"';
                returnHtml += '>' + booleanValsSeperate[k] + '</option>';
            }
            returnHtml += '</select>';
            return (returnHtml);
        };
        ServiceOption.getHTMLForDataTypeNumberHtml = function (dataType, parameterName, defaultValue) {
            var returnHtml = "";
            returnHtml += '<input class="serviceoptions ' + BASWebServices.ConfigService.STANDARD_CLASS_FOR_OPTIONS + '" ';
            returnHtml += 'data-ng-model="soc.' + parameterName + '"';
            returnHtml += 'data-ng-init="soc.' + parameterName + '=\'' + defaultValue + '\'"';
            returnHtml += 'data-ng-change="soc.changeOfInput(\'' + parameterName + '\', soc.' + parameterName + ')"';
            returnHtml += ' type="text" ';
            returnHtml += ' id="' + parameterName + '"';
            returnHtml += ' name="' + parameterName + '"';
            returnHtml += ' value=' + defaultValue + '';
            returnHtml += ' size=4';
            returnHtml += '>';
            return (returnHtml);
        };
        ServiceOption.getHTMLForDataTypePositiveIntegerWithRange = function (dataType, parameterName, defaultValue) {
            var returnHtml = "";
            var minMaxSeperate = dataType.split("{")[1].split("}")[0].split(" ");
            var minVal = minMaxSeperate[0].split("=")[1];
            var maxVal = minMaxSeperate[1].split("=")[1];
            minVal = minVal.replace(/"/g, '');
            maxVal = maxVal.replace(/"/g, '');
            returnHtml += '<input type="number"';
            returnHtml += 'data-ng-model="soc.' + parameterName + '"';
            returnHtml += 'data-ng-init="soc.' + parameterName + '=' + defaultValue + '"';
            returnHtml += 'data-ng-change="soc.changeOfInput(\'' + parameterName + '\', soc.' + parameterName + ')"';
            returnHtml += ' class="serviceoptions ' + BASWebServices.ConfigService.STANDARD_CLASS_FOR_OPTIONS + '" ';
            returnHtml += ' id="' + parameterName + '" ';
            returnHtml += ' name="' + parameterName + '" ';
            returnHtml += ' size=6';
            if (parseInt(minVal) >= 0) {
                returnHtml += ' step="1" min=' + minVal + ' max=' + maxVal + ' value="' + defaultValue + '"';
                returnHtml += ' oninput="validity.valid||(value=\'\') ';
            }
            returnHtml += '"/>';
            return (returnHtml);
        };
        ServiceOption.getHTMLForDataTypeDecimalWithRange = function (dataType, parameterName, defaultValue) {
            var returnHtml = "";
            var minMaxSeperate = dataType.split("{")[1].split("}")[0].split(" ");
            var minVal = minMaxSeperate[0].split("=")[1];
            var maxVal = minMaxSeperate[1].split("=")[1];
            minVal = minVal.replace(/"/g, '');
            maxVal = maxVal.replace(/"/g, '');
            returnHtml += '<input type="number"';
            returnHtml += 'data-ng-model="soc.' + parameterName + '"';
            returnHtml += 'data-ng-init="soc.' + parameterName + '=' + defaultValue + '"';
            returnHtml += 'data-ng-change="soc.changeOfInput(\'' + parameterName + '\', soc.' + parameterName + ')"';
            returnHtml += ' class="serviceoptions ' + BASWebServices.ConfigService.STANDARD_CLASS_FOR_OPTIONS + '" ';
            returnHtml += ' id="' + parameterName + '" ';
            returnHtml += ' name="' + parameterName + '" ';
            returnHtml += ' size=6';
            returnHtml += ' step="0.01" min=' + minVal + ' max=' + maxVal + ' value="' + defaultValue + '"';
            if (parseFloat(minVal) >= 0) {
                returnHtml += ' oninput="validity.valid||(value=\'\') ';
            }
            else {
                returnHtml += ' onKeyDown="if(this.value.length < ' + minVal + ' || this.value.length < ' + maxVal + ') return false;" ';
            }
            returnHtml += '"/>';
            return (returnHtml);
        };
        ServiceOption.MAX_NUM_DEFAULT_OPTIONS_FOR_PIPELINE = 5;
        return ServiceOption;
    }());
    BASWebServices.ServiceOption = ServiceOption;
})(BASWebServices || (BASWebServices = {}));
//# sourceMappingURL=ServiceOption.js.map